"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data = {
    empty: {
        titleText: 'No Data'
    },
    modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        confirmText: 'OK'
    },
    form: {
        submitText: 'OK',
        cancelText: 'Cancel'
    },
    select: {
        emptyText: 'No result'
    },
    checkbox: {
        checkAllText: 'Check all'
    },
    textInput: {
        clearText: 'Clear input'
    },
    table: {
        filter: {
            okText: 'Ok',
            resetText: 'Reset'
        },
        emptyText: 'No Data'
    },
    datePicker: {
        rangeDateText: ['Start date', 'End date'],
        rangeTimeText: ['Start time', 'End time'],
        dateText: 'Select date',
        timeText: 'Select time',
        locale: 'en_US',
        today: 'Today',
        now: 'Now',
        backToToday: 'Back to today',
        ok: 'Ok',
        clear: 'Clear',
        month: 'Month',
        year: 'Year',
        timeSelect: 'select time',
        dateSelect: 'select date',
        weekSelect: 'Choose a week',
        monthSelect: 'Choose a month',
        yearSelect: 'Choose a year',
        decadeSelect: 'Choose a decade',
        yearFormat: 'YYYY',
        dateFormat: 'M/D/YYYY',
        dayFormat: 'D',
        dateTimeFormat: 'M/D/YYYY HH:mm:ss',
        monthBeforeYear: true,
        previousMonth: 'Previous month (PageUp)',
        nextMonth: 'Next month (PageDown)',
        previousYear: 'Last year (Control + left)',
        nextYear: 'Next year (Control + right)',
        previousDecade: 'Last decade',
        nextDecade: 'Next decade',
        previousCentury: 'Last century',
        nextCentury: 'Next century'
    }
};
exports.default = data;
//# sourceMappingURL=en.js.map